import React, { ReactNode, useContext } from 'react';
import { PrecheckContext } from '../../contexts/PrecheckContext';
import { FormattedMessage } from 'react-intl';
import NameAndMobile from './NameAndMobile';

// const trailerTypeList = ['Dry Van', 'Refrigerated'];
const trailerSizeList = ['46', '48', '53', '57'];
const trailerExistsOptions = ['Drop and Hook', 'Bobtail'];

const Preload = () => {
    const { precheckInfo, setPrecheckInfo } = useContext(PrecheckContext);
    return (
        <>
            <NameAndMobile />
            <div className="form-group mb-20">
                <label htmlFor="pickupNumber">
                    <FormattedMessage
                        id="driverInfoEntryInputLabelPickupOrDelivery"
                        defaultMessage="Pick-up or Delivery Number"
                    />
                </label>
                <FormattedMessage
                    id="driverInfoEntryInputPlaceholderPickupOrDelivery"
                    defaultMessage="Example: 35xxxxxx (8 digits)">
                    {(placeholder: ReactNode) => (
                        <input
                            type="text"
                            className="form-control"
                            name="pickupNumber"
                            id="pickupNumber"
                            placeholder={placeholder as string}
                            value={precheckInfo.submittedReferenceId}
                            onChange={(e) =>
                                setPrecheckInfo({
                                    ...precheckInfo,
                                    submittedReferenceId: e.target.value
                                })
                            }
                        />
                    )}
                </FormattedMessage>
            </div>
            <div className="form-group mb-20">
                <label className="mb-2">
                    <FormattedMessage
                        id="driverInfoEntryInputLabelHasTrailer"
                        defaultMessage="Drop-Off Trailer Size"
                    />
                </label>
                <div className="check-box-wrapper d-flex">
                    {trailerExistsOptions.map((trailerOption: string) => {
                        return (
                            <div className="form-check" key={trailerOption}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="trailerOption"
                                    id={`size-${trailerOption}`}
                                    hidden
                                    checked={
                                        (precheckInfo.hasTrailer &&
                                            trailerOption === 'Drop and Hook') ||
                                        (!precheckInfo.hasTrailer && trailerOption === 'Bobtail')
                                    }
                                    onChange={(e) =>
                                        setPrecheckInfo({
                                            ...precheckInfo,
                                            hasTrailer:
                                                e.target.value === 'Drop and Hook' ? true : false
                                        })
                                    }
                                    value={trailerOption}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={`size-${trailerOption}`}>
                                    {trailerOption}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
            {precheckInfo.hasTrailer ? (
                <>
                    <div className="form-group mb-20">
                        <label>
                            <FormattedMessage
                                id="driverInfoEntryInputLabelDropOffTrailerNumber"
                                defaultMessage="Drop Off Trailer Number"
                            />
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            name="trailerNumber"
                            id="trailerNumber"
                            placeholder="abc123"
                            value={precheckInfo.submittedTrailerNumber}
                            onChange={(e) =>
                                setPrecheckInfo({
                                    ...precheckInfo,
                                    submittedTrailerNumber: e.target.value
                                })
                            }
                        />
                    </div>
                    <label className="mb-2">
                        <FormattedMessage
                            id="driverInfoEntryInputLabelDropOffTrailerSize"
                            defaultMessage="Drop-Off Trailer Size"
                        />
                    </label>
                    <div className="check-box-wrapper d-flex">
                        {trailerSizeList.map((trailerSize: string) => {
                            return (
                                <div className="form-check" key={trailerSize}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="trailerSize"
                                        id={`size-${trailerSize}`}
                                        hidden
                                        checked={
                                            String(trailerSize) ===
                                            precheckInfo.submittedTrailerLength
                                        }
                                        onChange={(e) =>
                                            setPrecheckInfo({
                                                ...precheckInfo,
                                                submittedTrailerLength: e.target.value
                                            })
                                        }
                                        value={trailerSize}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`size-${trailerSize}`}>
                                        {trailerSize}
                                    </label>
                                </div>
                            );
                        })}
                    </div>{' '}
                </>
            ) : (
                <></>
            )}
        </>
    );
};

export default Preload;
